import React from 'react';
const problems = [{
  title: '😰 Information Is Everywhere...',
  lines: ['Home Assistant. Matter. Zigbee. Thread. Wi-Fi. ESPHome. Shelly.', 'Hundreds of devices. Thousands of tutorials. Everyone explains things differently.', 'Instead of learning step by step... You spend hours jumping between videos, websites, forums, and Facebook groups without knowing where to start.']
}, {
  title: '⚠️ Afraid Of Making Expensive Mistakes',
  lines: ["You don't want to damage expensive equipment. You don't want to wire something incorrectly. You don't want devices that refuse to connect. You don't want automations that constantly fail.", 'Without a structured learning system... Even simple installations can feel overwhelming.']
}, {
  title: '🔌 No Clear Installation Process',
  lines: ['You keep asking yourself... Which ecosystem should I choose? Which devices actually work together? How do I plan an installation? What should I buy first? How do professionals complete projects from start to finish?', 'Without a proven workflow... Every project feels confusing before it even begins.']
}, {
  title: '😩 Turning Knowledge Into Income Feels Impossible',
  lines: ['Maybe you\'ve even wondered... "Could I actually charge for this?" "Would anyone hire me?" "How do installers price Smart Home projects?" "What documents do professionals use?" "How do I find my first client?"', 'Learning technology is only half the challenge. Building a real service business is the other half.']
}];
export function PainSection() {
  return <section className="border-y border-brand-line bg-brand-light px-4 py-5" data-id="element-94" data-mp="3iofelylvnvam">
      <div className="mx-auto max-w-4xl" data-id="element-95" data-mp="3du1fpm80b617">
        <h2 className="mb-2 text-center font-display text-xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-96" data-mp="2q61o6k2vfblk">
          Does This Sound Familiar?
        </h2>
        <div className="mx-auto mb-3 max-w-3xl space-y-1 text-center text-sm font-normal leading-snug text-brand-muted sm:text-base" data-id="element-97" data-mp="2l6fa68f7xrbp">
          <p data-id="element-98" data-mp="u2wxx7rhz1d4">
            You've been thinking about learning Smart Home installation because you know demand is
            growing... More homeowners want smart lighting. Smart locks. Security cameras. Voice
            assistants. Energy automation. Complete connected homes.
          </p>
          <p data-id="element-99" data-mp="12x1orr6mscsn">
            And every year, more professionals are adding Smart Home services to their businesses.
            But when you finally decide to learn... You quickly realize how confusing everything
            becomes.
          </p>
          <p data-id="element-100" data-mp="f4l1n281dumh">
            If you're completely new to Smart Home installation... Or you're an electrician,
            technician, security installer, or DIY enthusiast looking to expand your skills...
            You've probably experienced at least one of these situations.
          </p>
        </div>

        <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-101" data-mp="1vil008r8hc7m">
          {problems.map(problem => <article key={problem.title} className="rounded-xl border border-brand-line bg-white p-3 shadow-sm" data-id="element-102" data-mp="25mrnj7w74a2k">
              <h3 className="mb-1 font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-103" data-mp="1vy00ne5zsfyi">
                {problem.title}
              </h3>
              {problem.lines.map(line => <p key={line} className="mt-0.5 text-xs font-normal leading-snug text-brand-muted sm:text-sm" data-id="element-104" data-mp="1mx1vutnqc4ev">
                  {line}
                </p>)}
            </article>)}
        </div>
      </div>
    </section>;
}